module.exports = __webpack_public_path__ + "static/media/cdos_94.172e8ad6.jpg";